import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken, redirectToSSO, isLoginBySSO } from '@/utils/auth' // 验权
import {setCookie,getCookie} from '@/utils/support'

const whiteList = ['/login','/loginBySSO'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (false /* TODO 暂时取消权限验证 store.getters.roles.length === 0 */) {
      // if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          let menus=res.data.menus;
          let username=res.data.username;
          store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({ ...to, replace: true })
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    // 用户未登录时的逻辑
    if (whiteList.indexOf(to.path) !== -1) {
      // 如果用户访问的是白名单中的路径，则直接放行
      next()
    } else {
      // 其余路径重定向到登录页
      if (to.query.sso_token) {
        // 有这个参数表明是SSO登录完成后的回调，进入token验证环节
        store.dispatch('VerifySsoToken', to.query.sso_token).then(() => {
          const username = getCookie("username")
          const password = getCookie("password")
          setCookie("username", username || 'admin', 15)
          setCookie("password", password || '', 15)
          // 构建新的查询参数，删除 sso_token，避免路径上显示这个参数
          const newQueryParams = { ...to.query }
          delete newQueryParams.sso_token

          // 使用 router.replace 更新 URL，保留其他参数
          router.replace({ path: to.path, query: newQueryParams })
          next()
        }).catch(() => {
          Message.error('SSO token verification failed, please try again')
          next('/login')
        }).finally(() => {
          NProgress.done()
        })
      } else if (isLoginBySSO()) {
        // SSO 登录
        const baseUrl = window.location.origin + window.location.pathname
        const pathAndHash = window.location.hash.split('?')[0] // 获取 # 后的路径部分
        const existingQueryParams = window.location.hash.split('?')[1] || '' // 获取 # 后的查询参数部分

        // 构建新的查询参数，增加 FROM_SSO=1
        const newQueryParams = existingQueryParams ? `?${existingQueryParams}&sso_token=SSO_TOKEN` : '?sso_token=SSO_TOKEN'
        const redirectUrl = encodeURIComponent(`${baseUrl}${pathAndHash}${newQueryParams}`)

        redirectToSSO("login", true, redirectUrl)
      } else {
        // 本地登录或LDAP登录的页面
        next('/login')
      }

      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js